'use strict';

import {findAll} from '../../../JavaScript/Utils';

const openChatWindow = (e) => {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    if (typeof window.psmSHvow === 'function') {
        window.psmSHvow();
    } else {
        window.open('https://vm.providesupport.com/0jwvdlxj5tao11kz09ift6mydq', 'chat', 'width=550,height=600,resizable=yes,scrollbars=yes');
    }
};

const chatButton = () => {
    const $chatButtons = findAll('.chat__button, .green-chat, .chat-button-mSHv, [data-nezzo-chat-button]', document);

    $chatButtons.forEach($button => {
        $button.addEventListener('click', openChatWindow);
    });

    // Delegate clicks for dynamically injected ProvideSupport elements
    document.addEventListener('click', (e) => {
        const target = e.target.closest('.chat__button, .green-chat a, .chat-button-mSHv, [data-nezzo-chat-button]');
        if (target) {
            openChatWindow(e);
        }
    });
};

document.addEventListener('DOMContentLoaded', function() {
    chatButton();
});

